<script lang="ts">
// 组件名称，用于 keep-alive 的 include 属性匹配
// 必须与 App.vue 中 keepAliveComponents 数组中的名称一致
export default {
  name: 'MobileNews'
}
</script>
<template>
  <div class="news">
    <div class="news-banner">
      <img :src="loadUrl.news" />
      <div>公司动态</div>
    </div>
    <div class="news-content">
      <div v-for="(item, index) in newsList" :key="index" @click="toOtherPath(item.relatedHtmlId, item.title)">
        <div>
          <img :src="item.ossPath" />
        </div>
        <div class="content">
          <div class="title">{{ item.title }}</div>
          <div class="detail">{{ item.introduction }}</div>
          <div class="createTime">{{ formatDate(item.newsTimestamp) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { asynchronousRetrieval } from '@/utils'
const loadUrl: any = ref({})

const newsList: any = ref([])

const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

const formatDate = (timestamp: number) => {

   const date = new Date(timestamp)
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = date.getHours();
    const mx = date.getMinutes();
    const s = date.getSeconds();

    return `${y}-${m}-${d}`
}



onMounted(async () => {
  // 条件判断：只有当数据为空时才请求接口
  // 因为组件被 keep-alive 缓存，再次进入页面时 onMounted 仍会执行
  // 但数据已经存在，不需要重新请求
  if (newsList.value.length === 0) {
    selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
      newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0))
    })
  }

  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.news) {
    const news: any = await asynchronousRetrieval('webimg/images/about_us/news.png');
    loadUrl.value = { news }
  }
})
</script>
<style scoped lang="less">
.news {
  min-height: calc(100vh - 400rem);
  background: #EFEFEF;

  .news-banner {
    position: relative;
    height: 208rem;
    line-height: 208rem;
    text-align: center;
    font-weight: 600;
    font-size: 40rem;
    color: #FFFFFF;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    &>div {
      position: relative;
      z-index: 1;
    }
  }

  .news-content {
    margin: 46rem 0 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    &>div {
      width: 680rem;
      background: #FFFFFF;
      border-radius: 32rem;
      box-sizing: border-box;
      cursor: pointer;
      padding: 24rem 24rem 34rem;
      margin-bottom: 48rem;

      &:hover {
        box-shadow: 0px 10px 12px 0px rgba(46, 118, 255, 0.2), 0px 0px 4px 0px rgba(46, 118, 255, 0.2);
      }

      img {
        width: 630rem;
        height: 354rem;
        border-radius: 20rem;
      }

      .content {
        width: 632rem;
        text-align: left;
        color: #0A0A0A;
        font-family: PingFangSC-Medium;

        .title {
          font-weight: 600;
          font-size: 30rem;
          color: #414141;
          line-height: 48rem;
          margin-top: 10rem;
        }

        .detail {
          font-weight: 400;
          font-size: 20rem;
          color: #414141;
          line-height: 30rem;
          margin-top: 6rem;
          font-family: PingFangSC-Regular;
        }

        .createTime {
          font-weight: 400;
          font-size: 20rem;
          color: #414141;
          line-height: 30rem;
          margin-top: 8rem;
        }
      }
    }
  }
}
</style>
